import {createAction, props} from '@ngrx/store';
import {EkranPodsumowaniaActionType} from './ekran-podsumowania-action-type';
import {
  ParametryZbioruUszkodzenPrzedmiotow,
  ZbiorUszkodzenPrzedmiotow
} from '../../../../../../shared/store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotow';
import {Samoobsluga} from '../../../../../../shared/services/samoobsluga/types/samoobsluga';

export const kliknietoKalkuluj = createAction(
  EkranPodsumowaniaActionType.KLIKNIETO_KALKULUJ,
  props<{ correlationId: string, zbiorUszkodzenPrzedmiotow: ZbiorUszkodzenPrzedmiotow<ParametryZbioruUszkodzenPrzedmiotow>[]}>()
);

export const kliknietoKalkulujSuccess = createAction(
  EkranPodsumowaniaActionType.KLIKNIETO_KALKULUJ_SUCCESS, props<Samoobsluga>()
);

export const zapiszStore = createAction(
  EkranPodsumowaniaActionType.ZAPISZ_STORE
);

export const kliknietoWyliczPozniej = createAction(
  EkranPodsumowaniaActionType.KLIKNIETO_WYLICZ_POZNIEJ, props<{correlationId: string}>()
);

export const kliknietoWyliczPozniejSuccess = createAction(
  EkranPodsumowaniaActionType.KLIKNIETO_WYLICZ_POZNIEJ_SUCCESS, props<Samoobsluga>()
);
